import React from "react";
import { Container, Typography, Link } from "@mui/material";

const Contact = () => {
  return (
    <Container maxWidth="md" sx={{ pt: 26, pb: 14 }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 100,
          letterSpacing: 1,
          mb: 4,
        }}
      >
        Contact & Customer Service
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Should you have any questions, please refer to our{" "}
        <Link href="/faq" underline="hover">
          FAQ page
        </Link>
        . If you do not find the answer to your query, we will happily help.
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        • Email: contact@daina.com
      </Typography>

      <Typography variant="body1">
        Please note that our customer service operates from Monday to Friday
        between 8AM and 5PM (IST time).
      </Typography>
    </Container>
  );
};

export default Contact;
